// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-svg{stroke:#00f!important;stroke-width:4px!important;outline:3px solid green!important}", ""]);
// Exports
module.exports = exports;
